// extracted by mini-css-extract-plugin
module.exports = {"TwoDimsFeature":"wn_a bhs_b bhs_ux"};